import {Injectable} from '@angular/core';
import * as moment from 'moment/moment';
import {FilterOperationModel} from '../shared/models/shared.model';

export class FilterBuilderService {
	private filterList = [];
	private filter = [];
	private createdOn = 'CreatedOn';
	private modifiedOn = 'ModifiedOn';
	private reviewedOn = 'ReviewedOn';

	constructor() {
	}

	public handleNotFilterFormatting(rawFilter: any[]) {
		let filters: any[] = [];
		if (this.isNestedFilterObject(rawFilter) &&  !this.isFilterContainNotCondition(rawFilter)) {
			filters = rawFilter;
		} else if (rawFilter[0] === '!') {
			filters = this.assignAndConditionToNotIncludeFilter(rawFilter[1]);
		} else {
			rawFilter.forEach(filterItem => {
				if (filterItem !== 'and' && filterItem !== 'or') {
					if (filterItem[0] === '!') {
						const data = this.assignAndConditionToNotIncludeFilter(filterItem[1]);
						filters.push(...data);
					} else {
						filters.push(filterItem);
					}
				} else {
					filters.push(filterItem);
				}
			});
		}
		return(filters);
	}

	public filterFormatting(rawFilter: any[]) {
		this.filterList = [];
		const flatFilters = this.flattenFilterList(rawFilter);
		const param = this.handleEqualDate(flatFilters);
		const filterOperation: FilterOperationModel[] = [];
		if (this.isNestedFilterObject(param)) {
			let index = 1;
			const filterLength = param.length;
			if (this.isBetweenDateFilter(param)) {
				const data = this.formatDateBetweenOperation(param);
				filterOperation.push(...data);
			} else {
				param.forEach(filterItem => {
					if (filterItem !== 'and' && filterItem !== 'or') {
						if (this.isBetweenDateFilter(filterItem)) {
							const data = this.formatDateBetweenOperation(filterItem);
							filterOperation.push(...data);
						} else {
							const condition = index === filterLength ? param[index - 2] : param[index];
							const operationType = this.getTypeOfValue(filterItem[2], filterItem[0]);
							if (this.isDateColumn(filterItem[0])) {
								const date = this.formatDate(filterItem[2]);
								filterOperation.push({
									column: filterItem[0],
									operation: filterItem[1],
									value: date,
									type: 'date',
									condition: condition
								});
							} else if (operationType === 'boolean') {
								filterOperation.push({
									column: filterItem[0],
									operation: filterItem[1],
									value: String(+filterItem[2]),
									type: 'number',
									condition: condition
								});
							} else {
								filterOperation.push({
									column: filterItem[0],
									operation: filterItem[1],
									value: String(filterItem[2]),
									type: operationType,
									condition: condition
								});
							}
						}
					}
					index++;
				});
			}
		} else {
			const operationType = this.getTypeOfValue(param[2], param[0]);
			const isDate = this.isDateColumn(param[0]);
			if (operationType === 'boolean') {
				filterOperation.push({
					column: param[0],
					operation: param[1],
					value: String(+param[2]),
					type: 'number',
				});
			} else {
				filterOperation.push({
					column: param[0],
					operation: param[1],
					value: isDate ? param[2].toLocaleString() : String(param[2]),
					type: operationType
				});
			}
		}

		return filterOperation;
	}

	private flattenFilterList(rawFilter: any[]) {
		if (this.isNestedFilterObject(rawFilter)) {
			rawFilter.forEach(filterItem => {
				if (filterItem !== 'and' && filterItem !== 'or') {
					if (this.isNestedFilterObject(filterItem) && !this.isBetweenDateFilter(filterItem)) {
						this.flattenFilterList(filterItem);
					} else {
						this.filterList.push(filterItem);
					}
				} else {
					this.filterList.push(filterItem);
				}
			});
		} else {
			this.filterList.push(...rawFilter);
		}

		return this.filterList;
	}

	// Check if it is not include filters
	private isFilterContainNotCondition(param) {
		let result = false;
		for (const filterItem of param) {
			if (filterItem !== 'and' && filterItem !== 'or') {
				const isNot = filterItem.includes('!');
				if (isNot) {
					result = true;
					break;
				}
			}
		}
		return result;
	}

	// Use and condition for not include filter
	private assignAndConditionToNotIncludeFilter(rawFilter: any[]) {
		const filter: any[] = [];
		if (!this.isNestedFilterObject(rawFilter)) {
			rawFilter[1] = '!=';
			filter.push(rawFilter);
		} else {
			for (let filterItem of rawFilter) {
				if (filterItem !== 'and' && filterItem !== 'or') {
					filterItem[1] = '!=';
				} else {
					filterItem = 'and';
				}
				filter.push(filterItem);
			}
		}
		return filter;
	}

	private isNestedFilterObject(param) {
		const isAnd = param.includes('and');
		const isOr = param.includes('or');

		return isAnd || isOr ? true : false;
	}

	private isBetweenDateFilter(param) {
		if (param && param[0] && param[2]) {
			const startDate = param[0];
			const endDate = param[2];

			const startDateColumnName = startDate[0];
			const endDateColumnName = endDate[0];

			if (
				this.isDateColumn(startDateColumnName) &&
				this.isDateColumn(endDateColumnName) &&
				startDateColumnName === endDateColumnName &&
				startDate[1] === '>=' &&
				endDate[1] === '<=') {
				return true;
			}
		}

		return false;
	}

	private isDateColumn(column) {
		return (column === this.createdOn || column === this.modifiedOn || column === this.reviewedOn);
	}

	private formatDate(date) {
		return moment(date).format('YYYY-MM-DD').toString();
	}

	private getTypeOfValue(value, column?) {
		let operationType = 'string';
		if (this.isDateColumn(column)) {
			operationType = 'date';
		} else if (typeof value === 'number') {
			operationType = 'number';
		} else if (typeof value === 'boolean') {
			operationType = 'boolean';
		} else {
			operationType = 'string';
		}
		return operationType;
	}

	private formatDateBetweenOperation(param) {
		const startDate = param[0];
		const endDate = param[2];

		const columnName = startDate[0];

		const res: FilterOperationModel[] = [];

		res.push({
			column: columnName,
			operation: 'between',
			value: this.formatDate(startDate[2]),
			type: 'date',
			condition: 'and',
			secondValue: this.formatDate(endDate[2])
		});

		return res;
	}

	private handleEqualDate(params: any[]) {
		const allArrayTypeFilters = params.filter(filter => Array.isArray(filter) && filter[1] === '>=');
		allArrayTypeFilters.forEach(filter => {
			params.forEach(filterItem => {
				if (filterItem[0] === filter[0] && filterItem[1] === '<') {
					filterItem[2] = moment(filterItem[2]).utcOffset(0).set(({hour: 23, minute: 59, second: 59, millisecond: 0})).toISOString();
				}
			});
			params.forEach(filterItem => {
				if (filterItem[0] === filter[0] && filterItem[1] === filter[1] && filterItem[2] === filter[2]) {
					filterItem[2] =  moment(filterItem[2]).utcOffset(0).set(({hour: 0, minute: 0, second: 0, millisecond: 0})).toISOString();
				}
			});
		});
		return params;
	}
}
